import { render, staticRenderFns } from "./marking.vue?vue&type=template&id=9e7ed82c&scoped=true"
import script from "./marking.vue?vue&type=script&lang=js"
export * from "./marking.vue?vue&type=script&lang=js"
import style0 from "./marking.vue?vue&type=style&index=0&id=9e7ed82c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_n3acbem2au4l2e3t4qvos3rwwq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e7ed82c",
  null
  
)

export default component.exports